import React, { Component } from "react";
import PropTypes from "prop-types";
import { logToSentry } from "../../utils/telemetry";

// Components
import Paragraph from "../Atoms/Paragraph";

// Stylesheets
import "./LazyLoadErrorBoundary.scss";

/**
 * Error boundary for failed chunkfile downloads
 * See: https://reactjs.org/docs/error-boundaries.htm
 */
class LazyLoadErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logToSentry(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="lazy_load_error_boundary">
          <div className="container">
            <Paragraph className="body_primary">
              Loading failed! Please reload the page.
            </Paragraph>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

LazyLoadErrorBoundary.propTypes = {
  children: PropTypes.any.isRequired,
};

export default LazyLoadErrorBoundary;
